import styled, { css } from 'styled-components';
import { calendarTokens } from '@forecast-it/design-system';
const tokens = calendarTokens.calendar;
export const Ellipsis = styled.div `
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	word-break: break-all;
`;
export const HeaderContainer = styled.div `
	display: flex;
	height: 100%;
`;
export const HeaderText = styled.div `
	color: ${tokens.color.text.content.auxiliary} ${tokens.font.cell.bold};
`;
export const CellTextBold = styled.div `
	${({ color }) => css `
			color: ${color === 'onLight'
    ? `${tokens.color.text.content.onlight}`
    : color === 'disabledOnDisabled'
        ? `${tokens.color.text.content.auxiliary}`
        : `${tokens.color.text.content.main}`};
		`}
	${tokens.font.cell.bold}
`;
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const CellText = styled(Ellipsis) `
	${({ color }) => css `
			color: ${color === 'onLight'
    ? `${tokens.color.text.content.onlight}`
    : color === 'disabledOnDisabled'
        ? `${tokens.color.text.content.auxiliary}`
        : `${tokens.color.text.content.main}`};
		`}
	${tokens.font.cell.regular}
`;
const afterRules = css `
	border-radius: inherit;
	content: '';
	position: absolute;
	top: -1px;
	right: -1px;
	bottom: -1px;
	left: -1px;
	pointer-events: none;
`;
const weekBorder = `
	position: relative;

	&:after {
		${afterRules};
		border-top: solid 1px ${tokens.color.border.midemphasis};
		border-bottom: solid 1px ${tokens.color.border.midemphasis};
	}

	&:last-of-type {
		position: relative;

		&:after {
			${afterRules};
			border-right: solid 1px ${tokens.color.border.midemphasis};
		}
	}
`;
export const RowWrapper = styled.div `
	display: contents;
	border-radius: inherit;
`;
export const DayInfoWrapper = styled.div `
	min-height: 48px;
`;
export const DayCellStyle = styled.div `
	height: 100%;
	width: 100%;
	padding: 8px;
	min-height: 60px;
	background-color: ${tokens.color.background.neutral[1]};
	cursor: pointer;

	outline-color: ${tokens.color.border.decorative};
	outline-style: solid;
	outline-width: 1px;

	${({ selected }) => selected === true &&
    css `
			outline-style: solid;
			outline-width: 1px;
			outline-color: ${tokens.color.border.midemphasis};
			z-index: 2;
		`}
	${({ hoverable, locked }) => hoverable !== false &&
    css `
			&:hover {
				background-color: ${locked ? `${tokens.color.background.neutral[2]}` : `${tokens.color.background.hover}`}
		`};
`;
export const WeekCellStyle = styled.div `
	height: 100%;
	width: 100%;
	padding: 8px;
	min-height: 60px;
	background-color: ${tokens.color.background.neutral[2]};

	cursor: pointer;

	outline-color: ${tokens.color.border.decorative};
	outline-style: solid;
	outline-width: 1px;

	${({ weekSelected }) => weekSelected &&
    css `
			position: relative;

			&:after {
				${afterRules};
				border-left: solid 1px ${tokens.color.border.midemphasis};
				border-top: solid 1px ${tokens.color.border.midemphasis};
				border-bottom: solid 1px ${tokens.color.border.midemphasis};
			}

			~ div {
				${weekBorder}
			}
		`}

	${({ hoverable }) => hoverable !== false &&
    css `
			&:hover {
				background-color: ${tokens.color.background.hover};
			}

			&:hover ~ ${DayCellStyle} {
				background-color: ${tokens.color.background.hover};
			}
		`}
`;
export const Grid = styled.div `
	${({ firstDayOfWeek, hideWeekend }) => firstDayOfWeek === 0
    ? css `
					${hideWeekend
        ? css `
								grid-template-columns: minmax(120px, 3fr) repeat(5, minmax(120px, 6fr));
						  `
        : css `
								grid-template-columns: minmax(120px, 3fr) minmax(120px, 3fr) repeat(5, minmax(120px, 6fr)) minmax(
										120px,
										3fr
									);
						  `}
			  `
    : css `
					${hideWeekend
        ? css `
								grid-template-columns: minmax(120px, 3fr) repeat(5, minmax(120px, 6fr));
						  `
        : css `
								grid-template-columns: minmax(120px, 3fr) repeat(5, minmax(120px, 6fr)) repeat(
										2,
										minmax(120px, 3fr)
									);
						  `}
			  `}

	display: grid;
	width: 100%;
	gap: 1px;
	padding: 1px;
	border-radius: 5px;

	> ${RowWrapper}:first-child {
		> ${DayCellStyle}:last-child {
			border-top-right-radius: inherit;
		}

		> ${WeekCellStyle}:first-child {
			border-top-left-radius: inherit;
		}
	}

	> ${RowWrapper}:last-child {
		> ${WeekCellStyle}:first-child {
			border-bottom-left-radius: inherit;
		}

		> ${DayCellStyle}:last-child {
			border-bottom-right-radius: inherit;
		}
	}
`;
